import React from 'react'
import "./Videos.css"

function Videos() {
  return (
    <>
    <div className='main_div69'>
        <h1 className='expertiese'>Our Experts Say</h1>
    

    <div className='vid_cont'>
   
    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" 
        src="https://www.youtube.com/embed/l4dc0rpL2MU"
         title="YouTube video player" 
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
         allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Sanjay Sapre – President, Franklin Templeton Asset Management (India) Pvt. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/dXeWvag2e5s" 
        title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Chandresh Kumar Nigam – Managing Director and CEO, Axis Asset Management Co. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/_FP7l7QULH8" 
        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Ashutosh Bishnoi – Managing Director and CEO, Mahindra Asset Management Co. Pvt. Ltd.
            </h3>
        </div>
    </div>

    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/hxPKEK8sfsU" 
        title="YouTube video player" 
        frameborder="0"
         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Ashish P Somaiyaa – Chief Executive Officer, Motilal Oswal Asset Management Co. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/OiVAZcmuMF8"
         title="YouTube video player" frameborder="0" 
         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
         allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Anthony Heredia – CEO, Baroda Pioneer Asset Management Co. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/p2HrWm_6vyU"
         title="YouTube video player"
          frameborder="0" 
         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            G Pradeepkumar, Chief Executive Officer - Union Asset Management Co. Pvt. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/DTgjOrhY5d8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Jignesh Shah – Chief Executive Officer - IL&FS <br/>Infra Asset Management Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/30_eANdmlMc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Kailash Kulkarni – Chief Executive Officer - L&T Investment Management Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/ClqLvHXC4gU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Kalpen Parekh – President - DSP BlackRock Investment Managers Pvt. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/1i5xA3JOjBE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Leo Puri – Managing Director - UTI Asset Management Co. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/rNqjKFeXyHU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Milind Barve - Managing Director - HDFC Asset Management Co. Ltd.
            </h3>
        </div>
    </div>


    <div className='card'>
        <div className='video_body'>
        <iframe width="360" height="315" src="https://www.youtube.com/embed/eaD_24cq4fY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div>
            <h3 className='video_title'>
            Neil Parikh – Chief Executive Officer, PPFAS Asset Management Pvt. Ltd.
            </h3>
        </div>
    </div>
    </div>
    </div>
    </>
  )
}

export default Videos